import { keyBy } from 'lodash/fp';
import { createReducer } from '@mews/framework';
import { FETCH_RESERVATION_GROUP_SUCCEEDED } from '../../reservationGroups/actionTypes';
import { RATES_SET } from './actionTypes';

const INITIAL_STATE = {};

export const ratesReducer = createReducer(INITIAL_STATE, {
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [RATES_SET]: (state, { rates }: $TSFixMe) => ({
        ...state,
        ...keyBy('id', rates),
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [FETCH_RESERVATION_GROUP_SUCCEEDED]: (state, { rates }: $TSFixMe) => ({
        ...state,
        ...keyBy('id', rates),
    }),
});
